import styled from 'styled-components';

export const TitleWrapper = styled.div`
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.backgrounds.tab};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.palette.neutral.lightest}`};
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-size: 30px;
  font-weight: 500;
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SubtitleColumn = styled.div``;

export const Subtitle = styled.div`
  font-size: 16px;
  margin-top: 10px;
`;
